import {Dispatch, FC, useState} from 'react';
import Modal from 'react-modal';
import {Button, ButtonWithLoader} from '../Button';
import {generalPopupStyles} from '../../../constants/popupStyles';
import {Form, Formik} from 'formik';
import {FormGroup} from '@mui/material';
import {TextField} from '../formik/fields';

const cancelLabel = 'Cancel';
const confirmLabel = 'Create';

Modal.setAppElement(document.getElementById('root'));

interface CreationPopupProps {
  labels?: {
    confirmBtn?: string,
    cancelBtn?: string,
  };
  inputFields: {name: string, label: string, value: string}[];
  validationSchema: any;
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  confirmableAction: (values: any) => void;
  apiValidationError: Nullable<Dictionary<string[]>>;
  setApiValidationError: Dispatch<Nullable<Dictionary<string[]>>>;
}

const CreationPopup: FC<CreationPopupProps> = ({
  labels={},
  inputFields,
  validationSchema,
  isOpen,
  setIsOpen,
  confirmableAction,
  apiValidationError,
  setApiValidationError
}) => {
  const [isCreating, setIsCreating] = useState(false);

  const initialValues = {};
  inputFields.map(({name, value}) => {
    initialValues[name] = value;
  });

  const closeModal = () => {
    setIsOpen(false);
  };

  const renderInputFields = () => {
    return (
      <>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            setIsCreating(true);
            await confirmableAction(values);
            setIsCreating(false);
          }}
        >
          {({setFieldTouched, isValid}) => {
            return (
              <Form className="creation-popup-form">
                {inputFields.map(({name, label}) => (
                  <FormGroup key={`${name}_${label}`}>
                    <TextField
                      id={name}
                      name={name}
                      label={label}
                      disabled={isCreating}
                      onBlur={() => {
                        setFieldTouched(name, true);
                      }}
                      apiValidationError={apiValidationError}
                    />
                  </FormGroup>
                ))}

                <div className="buttons">
                  <ButtonWithLoader
                    type="submit"
                    label={labels.confirmBtn || confirmLabel}
                    disabled={!isValid}
                    isSubmitting={isCreating}
                  />
                  <Button
                    disabled={isCreating}
                    label={labels.cancelBtn || cancelLabel}
                    variant="text"
                    onClick={() => {
                      setApiValidationError(null);
                      closeModal();
                    }}/>
                </div>
              </Form>);
          }}
        </Formik>
      </>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={generalPopupStyles}
      contentLabel="Creation Popup"
      shouldCloseOnOverlayClick={!isCreating}
    >
      {renderInputFields()}
    </Modal>);
};

export default CreationPopup;
